/* src/app/agent-builder/agent-builder-config/agent-builder-config.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
nz-form-item {
  margin-bottom: 16px;
  width: 100%;
}
.mcp-card {
  margin-bottom: 16px;
}
.quill-container {
  width: 100%;
}
nz-divider {
  margin: 24px 0;
}
nz-row {
  margin-bottom: 12px;
}
textarea[nz-input] {
  resize: vertical;
}
nz-empty {
  display: block;
  padding: 48px 0;
}
.tab-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
  width: 100%;
}
.salvar-agent-button {
  margin-top: 16px;
}
.row-insert-table {
  background-color: var(--tem-accent-soft);
}
.item-form-group {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 10px;
}
.system-prompt-history-select {
  width: 50%;
}
.system-prompt-history {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: right;
  padding: 10px;
  gap: 10px;
}
.system-prompt-history-redo {
  position: absolute;
  right: 0;
}
/*# sourceMappingURL=agent-builder-config.component.css.map */
